"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onInitialClientRender = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var onInitialClientRender = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_) {
    var pluginOptions,
        _debounce$showInProdu,
        debounce,
        showInProduction,
        axeOptions,
        axeContext,
        _yield$import,
        axe,
        _args = arguments;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pluginOptions = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _debounce$showInProdu = _objectSpread({
              debounce: 1000,
              showInProduction: false,
              axeOptions: {},
              axeContext: undefined
            }, pluginOptions), debounce = _debounce$showInProdu.debounce, showInProduction = _debounce$showInProdu.showInProduction, axeOptions = _debounce$showInProdu.axeOptions, axeContext = _debounce$showInProdu.axeContext;

            if (!(process.env.NODE_ENV === 'development' || showInProduction)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return Promise.resolve().then(function () {
              return (0, _interopRequireWildcard2["default"])(require('react-axe'));
            });

          case 5:
            _yield$import = _context.sent;
            axe = _yield$import["default"];
            axe(_react["default"], _reactDom["default"], debounce, axeOptions, axeContext);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onInitialClientRender(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.onInitialClientRender = onInitialClientRender;